export const Tick: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="9.414" height="7.207" viewBox="0 0 9.414 7.207">
        <g id="tick_boundaryless_v1_7a_2X" transform="translate(0.707 0.707)">
            <path
                id="tick_boundaryless_v1_7a_2X-2"
                data-name="tick_boundaryless_v1_7a_2X"
                d="M80,68l2,2,6-6"
                transform="translate(-80 -64)"
                fill="none"
            />
        </g>
    </svg>
);
